// ... existing code ...
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import ServicesGrid from './components/ServicesGrid';
import AIAnswerBlock from './components/AIAnswerBlock';
import ProcessSection from './components/ProcessSection';
import WhyChooseUs from './components/WhyChooseUs';
import ServiceAreas from './components/ServiceAreas';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import FinalCTA from './components/FinalCTA';
import MidPageCTA, { UrgencyCountdown } from './components/MidPageCTA';

export default function Home() {
  return (
    <div className="min-h-screen font-sans">
      <Header />
      <main>
        <HeroSection />
        <TrustBar />
        <ServicesGrid />
        <MidPageCTA variant="urgency" />
        <AIAnswerBlock />
        <ProcessSection />
        <WhyChooseUs />
        <ServiceAreas />
        <TestimonialsSection />
        <MidPageCTA variant="social" />
        <FAQSection />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
